/**
 * Writes the free space for an element's content: {width: its width, height: the window height} (px),
 * and updates it when the element or the window is resized.
 * Usage: <div available-size="ctrl.previewSpace"></div>
 */
class availableSizeDirective {
    constructor($parse) {
        "ngInject";
        this.restrict = "A";
        this.$parse = $parse;
    }

    link(scope, element, attrs) {
        const model = this.$parse(attrs.availableSize);
        const update = () => {
            const size = {width: element[0].clientWidth, height: window.innerHeight};
            const current = model(scope);
            if (!current || current.width !== size.width || current.height !== size.height) {
                scope.$applyAsync(() => model.assign(scope, size));
            }
        };

        update();
        window.addEventListener("resize", update);
        const observer = window.ResizeObserver ? new window.ResizeObserver(update) : null;
        if (observer) {
            observer.observe(element[0]);
        }

        scope.$on("$destroy", () => {
            window.removeEventListener("resize", update);
            if (observer) {
                observer.disconnect();
            }
        });
    }

    static create() {
        return new availableSizeDirective(...arguments);
    }
}

availableSizeDirective.create.$inject = ["$parse"];

export {availableSizeDirective};



// WEBPACK FOOTER //
// ./sources/directives/available-size.directive.js